import { useQuery } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL } from '../../constants/endpoints';
import { IServerErrorResponse } from '../../types';

interface IProps {
  customerId: string;
  companyId: string;
}
export interface IGustoWidgetDataResponse {
  paymentAmount: number;
  nextPaymentDate: string;
  gustoLink: string;
  companyName: string;
  gustoError?: {
    errorCode: number;
    title: string;
    text: string;
  };
}
export const useGetGustoDataForWidget = ({ customerId, companyId }:IProps, onSuccess?: (response: IGustoWidgetDataResponse) => void, onError?: (error: IServerErrorResponse) => void) => useQuery(
  ['getGustoDataForWidget', customerId],
  async () => {
    if (!customerId || !companyId) {
      return null;
    }
    const { data } = await httpService.get((`${BASE_URL}/api/v1/user/${customerId}/payroll/${companyId}/summary`));
    return data;
  },
  {
    enabled: false,
    retry: 0,
    onSuccess: (response: IGustoWidgetDataResponse) => {
      if (onSuccess) onSuccess(response);
    },
    onError: (error: IServerErrorResponse) => {
      if (onError) onError(error);
    },
  },
);
